import { api } from "utils/hostname";
import url from "url/index";
import { LANGUAGES, LanguageType } from "constants/languages";
import { LanguageResponseType } from "types/Catalogs";
import { setServiceError } from "stores/settings";

export const fetchLanguages = async (): Promise<LanguageType[]> => {
  try {
    const response = await api().get<LanguageResponseType>(
      url.config.api.catalogs.languages,
      {
        headers: {
          "f-v": import.meta.env.VITE_APP_VERSION_APP,
        },
      },
    );

    if (response.data.statusCode >= 500) {
      setServiceError(true);
      throw new Error("Server error");
    }
    return response.data.languages
      .map((language) => {
        const isoCode = language.isoCode.toUpperCase();
        if (!LANGUAGES[isoCode]) {
          return null;
        }
        return {
          ...language,
          isoCode: language.isoCode.toUpperCase(),
          img: LANGUAGES[isoCode].img,
        };
      })
      .filter((language) => !!language) as LanguageType[];
  } catch (error) {
    throw new Error("Fetch languages error");
  }
};
